import { render, staticRenderFns } from "./ServiceCostOverRevenueStatistics.vue?vue&type=template&id=3f0557bc"
import script from "./ServiceCostOverRevenueStatistics.vue?vue&type=script&lang=ts"
export * from "./ServiceCostOverRevenueStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports